import { useEffect } from 'react'

const META_PIXEL_ID = '2724560677910571'

let pixelInitialized = false

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

export function initMetaPixel() {
  if (typeof window === 'undefined') return
  if (pixelInitialized) return
  pixelInitialized = true
  ;(function (f: any, b: any, e: any, v: any) {
    if (f.fbq) return
    var n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = !0
    n.version = '2.0'
    n.queue = []
    var t = b.createElement(e)
    t.async = !0
    t.src = v
    var s = b.getElementsByTagName(e)[0]
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      b.head.appendChild(t)
    }
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )

  window.fbq('init', META_PIXEL_ID)
  window.fbq('track', 'PageView')
}

export function trackMetaEvent(
  eventName: string,
  params?: Record<string, any>,
) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, params)
  }
}

export function useMetaPixel() {
  useEffect(() => {
    initMetaPixel()
  }, [])

  return { trackMetaEvent }
}
